import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useContext, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import { EditCellContext } from 'src/contexts/EditCellContext';
import { informationIcon } from 'src/utils/icons';

const DepartmentGLCodes = (props: GridCellProps) => {
  const [cellClick] = useContext(EditCellContext);
  const { handleGLCodesOrMemberClick } = cellClick?.('');
  const { dataItem, field = '' } = props;
  const glCodes = useMemo(() => dataItem?.[field] || [], [dataItem, field]);
  const handleClick = useCallback(
    (e: any) => {
      e.stopPropagation();
      handleGLCodesOrMemberClick?.({
        data: { glCodes, departmentName: dataItem?.name || '' },
        type: field,
      });
    },
    [dataItem?.name, field, glCodes, handleGLCodesOrMemberClick]
  );

  return (
    <GridCellBase {...props} rowSelectionEnabled disableToolTip>
      <div className="flex justify-center items-center cursor-pointer">
        <span className="w-[90px]"> {glCodes.length} GL Codes</span>
        <div onClick={handleClick}>{informationIcon}</div>
      </div>
    </GridCellBase>
  );
};

export default DepartmentGLCodes;
